import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Input, InputNumber, Switch, Button, Card, message } from 'antd';
import axios from 'axios';
import { API_BASE_URL } from "../../config";

const EditSatCollection = () => {
    const { collection_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data } = await axios.get(`${API_BASE_URL}/api/SatCollection/${collection_id}`);
                form.setFieldsValue(data);
            } catch (error) {
                message.error('Failed to load collection data');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [collection_id, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            await axios.put(`${API_BASE_URL}/api/SatCollection/${collection_id}`, {
                id: collection_id,
                ...values,
            });

            message.success('Collection updated successfully');
            navigate('/sat-collections');
        } catch (error) {
            message.error('Failed to update collection');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card title="Edit SAT Collection" variant="borderless" style={{ maxWidth: 600, margin: '0 auto' }}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
                <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please enter a name' }]}>
                    <Input placeholder="Enter collection name" />
                </Form.Item>

                <Form.Item name="price" label="Price (UZS)" rules={[{ required: true, message: 'Please enter a price' }]}>
                    <InputNumber min={0} style={{ width: '100%' }} placeholder="Enter price" />
                </Form.Item>

                <Form.Item name="limit" label="Limit (max)" rules={[{ required: true, message: 'Please enter a limit' }]}>
                    <InputNumber min={1} max={100} style={{ width: '100%' }} placeholder="Enter limit" />
                </Form.Item>

                <Form.Item name="active" label="Active" valuePropName="checked">
                    <Switch />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Update Collection
                    </Button>
                </Form.Item>

                <Form.Item>
                    <Button type="default" onClick={() => navigate('/sat-collections')} block>
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default EditSatCollection;
